import { onDocumentLoaded } from "@theme/utilities";

function setFooterHeight(footer) {
  if (!footer) return;

  const content = footer.querySelector(".footer-content");
  if (!content) return;

  const contentHeight = content.scrollHeight;
  footer.style.setProperty("--footer-height", `${contentHeight}px`);
}

onDocumentLoaded(() => {
  const footer = document.querySelector(".footer");
  const header = document.getElementById("header-component");
  const fixedButton = document.getElementById("fixed-button");

  if (!footer || !header) return;

  setFooterHeight(footer);

  window.visualViewport?.addEventListener("resize", () =>
    setFooterHeight(footer),
  );
  window.addEventListener("resize", () => setFooterHeight(footer));

  const intersectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          footer.classList.add("visible");
          header.classList.add("hide");
          if (fixedButton) {
            fixedButton.classList.add("fixed-button-hidden");
          }
        } else {
          footer.classList.remove("visible");
          header.classList.remove("hide");
          if (fixedButton) {
            fixedButton.classList.remove("fixed-button-hidden");
          }
        }
      });
    },
    {
      threshold: [0.5],
      rootMargin: "0px",
    },
  );

  intersectionObserver.observe(footer);
});
